import {Chrome, Plus} from 'lucide-react';
import {Menu, MenuGroup, MenuItem} from '../../components';

interface StepDividerMenuProps {
  onAddManual: () => void;
  onAddBrowser: () => void;
}

export const StepDividerMenu = ({onAddManual, onAddBrowser}: StepDividerMenuProps) => (
  <Menu>
    <MenuGroup>
      <MenuItem icon={Plus} onClick={onAddManual}>
        Добавить шаг
      </MenuItem>
    </MenuGroup>
    <MenuGroup>
      <MenuItem icon={Chrome} onClick={onAddBrowser}>
        Записать шаги для сайта
      </MenuItem>
      {/* <MenuItem icon={WindowsMono}>Записать шаги на десктопе</MenuItem> */}
    </MenuGroup>
  </Menu>
);
